import React, { Component } from 'react';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import { addReac, getReac, updateReac, deleteReac } from '../../actions';
import { getReacData } from '../../common/store/reducers/reacondicionados';
import { getColumns } from '../services/config';
import SearcherPro from 'stock/components/SearcherPro';
import { filterReacDataByText } from '../services/filterReacData';
import { printReacLabel } from '../services/printLabel';
import executeImportExcelReac from '../services/ImportExcelReac';
import TableReac from '../components/TableReac';
import DialogImportReac from '../components/DialogImportReac';
import ImportProgressDialog from '../components/ImportProgressDialog';
import DeleteProgressDialog from '../components/DeleteProgressDialog';
import TestsDialog from 'tickets/components/TestsDialog';
import { addReac2, updateReac2, deleteReac2 } from '../../actions/reacondicionadosActions';
import addTicketFromReacUseCase from '../services/addTicketFromReacUseCase';
import addInvoiceFromReacUseCase from '../services/addInvoiceFromReacUseCase';
import findColumnsOrderUseCase from 'common/services/findColumnsOrderUseCase';
import updateColumnsOrderUseCase from 'common/services/updateColumnsOrderUseCase';

class ReacondicionadosContainer extends Component {

    constructor(props) {
        super(props);
        this.tableRef = React.createRef();
        this.tableRefVendidos = React.createRef();
        this.state = {
            importDialog:   { open: false, result: null },
            importProgress: { open: false, current: 0, total: 0 },
            testDialog:     { open: false, item: null },
            reacSelected:   [],
            selectAll:      false,
            deleteProgress: { open: false, current: 0, total: 0 },
            confirmDialog:  { open: false, type: null, items: [] },
            orderColumns:   {},
            searchData:     { text: '' },
        };
    }

    buildColumns(withCheckbox = true, orderColumns = {}) {
        const base = getColumns(this.handleChangeEstado, orderColumns);
        const checkboxCol = {
            title: '',
            field: '_selected',
            sorting: false,
            filtering: true,
            editable: 'never',
            cellStyle: { padding: '0 0 0 4px', width: 48 },
            headerStyle: { padding: '0 0 0 4px', width: 48 },
            filterComponent: () => (
                <Checkbox
                    color="primary"
                    checked={this.state.selectAll}
                    onChange={e => this.handleSelectAll(e.target.checked)}
                />
            ),
            render: rowData => {
                if (!rowData) return null;
                return (
                    <Checkbox
                        color="primary"
                        checked={!!rowData._selected}
                        onChange={e => this.handleCheckedSelected(rowData, e.target.checked)}
                    />
                );
            },
        };
        const cbOrder = (orderColumns || {})['_selected'];
        if (cbOrder != null) checkboxCol.tableData = { columnOrder: cbOrder };
        if (!withCheckbox) return base;
        return [checkboxCol, ...base];
    }

    async componentDidMount() {
        if (this.props.reacData.length === 0) {
            this.props.getReac();
        }
        try {
            const orderColumns = await findColumnsOrderUseCase({ doc: 'reacondicionados' });
            if (orderColumns) this.setState({ orderColumns });
        } catch (_) {}
    }

    handleSearchText = text => {
        this.setState({ searchData: { text } });
    };

    handleColumnDrag = (cols) => {
        const arr = document.getElementsByClassName('MuiInputBase-input');
        Array.from(arr).forEach(el => el.blur());

        // Actualizar estado local para que los re-renders no reseteen el orden
        const newOrder = {};
        cols.forEach(col => {
            if (col.field != null && col.tableData != null) {
                newOrder[col.field] = col.tableData.columnOrder;
            }
        });
        this.setState({ orderColumns: newOrder });

        updateColumnsOrderUseCase({ columns: cols, doc: 'reacondicionados' });
    };

    handleAdd = newItem => new Promise((resolve, reject) => {
        this.props.addReac({ data: newItem, resolve, reject });
    });

    handleUpdate = (newItem) => new Promise((resolve, reject) => {
        this.props.updateReac({ data: newItem, resolve });
    });

    handleDelete = (item) => new Promise(async (resolve) => {
        const { reacSelected } = this.state;
        if (reacSelected.length > 0) {
            const toDelete = [...reacSelected];
            const total = toDelete.length;
            this.setState({ deleteProgress: { open: true, current: 0, total } });
            let current = 0;
            for (const r of toDelete) {
                try { await deleteReac2(r); } catch (err) { console.error(err); }
                current++;
                this.setState({ deleteProgress: { open: true, current, total } });
            }
            this.setState({
                deleteProgress: { open: false, current: 0, total: 0 },
                reacSelected: [],
                selectAll: false,
            });
            resolve();
        } else {
            this.props.deleteReac({ data: item, resolve });
        }
    });

    handleCheckedSelected = (item, flag) => {
        item._selected = flag;
        this.setState(prev => {
            const filtered = prev.reacSelected.filter(r => r.id !== item.id);
            return { reacSelected: flag ? [...filtered, item] : filtered };
        });
    };

    handleSelectAll = (flag) => {
        const visible = this.tableRef.current
            ? this.tableRef.current.dataManager.searchedData
            : [];
        visible.forEach(r => { r._selected = flag; });
        this.setState({ selectAll: flag, reacSelected: flag ? [...visible] : [] });
    };

    handlePrintLabel = async item => {
        try {
            const { reacSelected } = this.state;
            const items = reacSelected.length > 0 ? reacSelected : [item];
            await printReacLabel(items);
        } catch (err) {
            console.error('Error al imprimir etiqueta:', err);
        }
    };

    handleDuplicate = async item => {
        const { id, reference, fechaVenta, ...rest } = item;
        const newItem = {
            ...rest,
            estado: 'stock',
            fechaVenta: null,
            fechaEntrada: new Date().getTime(),
        };
        try {
            await addReac2(newItem);
        } catch (err) {
            console.error('Error al duplicar artículo:', err);
        }
    };

    handleDownloadTemplate = async () => {
        const { default: ExcelJS } = await import('exceljs');
        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'TaskManager';

        const CAPACIDADES = ['64GB','128GB','256GB','512GB','1TB','2TB'];
        const COLORES = [
            'Blanco','Negro','Plata','Gris espacial','Dorado','Champán',
            'Medianoche','Estrella',
            'Azul','Azul cielo','Azul pacífico','Azul sierra','Azul alpino','Azul oscuro',
            'Verde','Verde alpino','Verde eucalipto','Verde pino','Verde azulado',
            'Rosa','Rosa claro','Rosa fuerte',
            'Rojo','Naranja','Amarillo','Amarillo cítrico',
            'Morado','Lila','Coral','Melocotón','Caqui',
            'Grafito',
            'Titanio natural','Titanio blanco','Titanio negro','Titanio arena',
        ];
        const RAM_OPTS = ['2GB','3GB','4GB','6GB','8GB','12GB','16GB','18GB','24GB','32GB','36GB','48GB','64GB','96GB','128GB','192GB'];
        const MODELOS = [
            'iPhone SE (1ª gen)','iPhone SE (2ª gen)','iPhone SE (3ª gen)',
            'iPhone 6','iPhone 6 Plus','iPhone 6s','iPhone 6s Plus',
            'iPhone 7','iPhone 7 Plus','iPhone 8','iPhone 8 Plus',
            'iPhone X','iPhone XS','iPhone XS Max','iPhone XR',
            'iPhone 11','iPhone 11 Pro','iPhone 11 Pro Max',
            'iPhone 12 mini','iPhone 12','iPhone 12 Pro','iPhone 12 Pro Max',
            'iPhone 13 mini','iPhone 13','iPhone 13 Pro','iPhone 13 Pro Max',
            'iPhone 14','iPhone 14 Plus','iPhone 14 Pro','iPhone 14 Pro Max',
            'iPhone 15','iPhone 15 Plus','iPhone 15 Pro','iPhone 15 Pro Max',
            'iPhone 16','iPhone 16 Plus','iPhone 16 Pro','iPhone 16 Pro Max',
            'MacBook Air M1','MacBook Air M2 13"','MacBook Air M2 15"',
            'MacBook Air M3 13"','MacBook Air M3 15"',
            'MacBook Air M4 13"','MacBook Air M4 15"',
            'MacBook Air 2020 (Intel)','MacBook Air 2019','MacBook Air 2018',
            'MacBook Pro 13" M1','MacBook Pro 13" M2','MacBook Pro 13" (Intel)',
            'MacBook Pro 14" M1 Pro','MacBook Pro 14" M1 Max',
            'MacBook Pro 14" M2 Pro','MacBook Pro 14" M2 Max',
            'MacBook Pro 14" M3','MacBook Pro 14" M3 Pro','MacBook Pro 14" M3 Max',
            'MacBook Pro 14" M4 Pro','MacBook Pro 14" M4 Max',
            'MacBook Pro 16" M1 Pro','MacBook Pro 16" M1 Max',
            'MacBook Pro 16" M2 Pro','MacBook Pro 16" M2 Max',
            'MacBook Pro 16" M3 Pro','MacBook Pro 16" M3 Max',
            'MacBook Pro 16" M4 Pro','MacBook Pro 16" M4 Max',
            'MacBook Pro 16" (Intel)',
            'MacBook 12" (2017)','MacBook 12" (2016)','MacBook 12" (2015)',
            'iPad 10ª gen','iPad 9ª gen','iPad 8ª gen','iPad 7ª gen','iPad 6ª gen','iPad 5ª gen',
            'iPad mini 7','iPad mini 6','iPad mini 5','iPad mini 4',
            'iPad Air M2 11"','iPad Air M2 13"',
            'iPad Air 5ª gen','iPad Air 4ª gen','iPad Air 3ª gen','iPad Air 2',
            'iPad Pro 11" M4','iPad Pro 11" (4ª gen)','iPad Pro 11" (3ª gen)',
            'iPad Pro 11" (2ª gen)','iPad Pro 11" (1ª gen)',
            'iPad Pro 13" M4','iPad Pro 12.9" (6ª gen)','iPad Pro 12.9" (5ª gen)',
            'iPad Pro 12.9" (4ª gen)','iPad Pro 12.9" (3ª gen)',
            'iPad Pro 12.9" (2ª gen)','iPad Pro 12.9" (1ª gen)',
            'iPad Pro 10.5"','iPad Pro 9.7"',
        ];

        const ws = workbook.addWorksheet('Reacondicionados');

        const listas = workbook.addWorksheet('Listas');
        listas.getCell('A1').value = 'Capacidad';
        listas.getCell('B1').value = 'Color';
        listas.getCell('C1').value = 'RAM';
        listas.getCell('D1').value = 'Modelo';
        listas.getRow(1).font = { bold: true };
        CAPACIDADES.forEach((v, i) => { listas.getCell(`A${i + 2}`).value = v; });
        COLORES.forEach((v, i)     => { listas.getCell(`B${i + 2}`).value = v; });
        RAM_OPTS.forEach((v, i)    => { listas.getCell(`C${i + 2}`).value = v; });
        MODELOS.forEach((v, i)     => { listas.getCell(`D${i + 2}`).value = v; });
        listas.getColumn('A').width = 14;
        listas.getColumn('B').width = 20;
        listas.getColumn('C').width = 10;
        listas.getColumn('D').width = 32;

        ws.columns = [
            { header: 'Referencia',        key: 'reference',          width: 14 },
            { header: 'Modelo',            key: 'modelo',             width: 22 },
            { header: 'Capacidad',         key: 'capacidad',          width: 12 },
            { header: 'Procesador',        key: 'procesador',         width: 16 },
            { header: 'RAM',               key: 'ram',                width: 10 },
            { header: 'Color',             key: 'color',              width: 14 },
            { header: 'Grado',             key: 'grado',              width: 8  },
            { header: 'Condición',         key: 'condicion',          width: 12 },
            { header: 'Salud (%)',         key: 'salud',              width: 10 },
            { header: 'Ciclos',            key: 'ciclos',             width: 8  },
            { header: 'Problema original', key: 'problemaOriginal',   width: 26 },
            { header: 'Precio',            key: 'precio',             width: 12 },
            { header: 'Precio s/IVA',      key: 'precioSinIva',       width: 14 },
            { header: 'Precio compra',     key: 'precioCompra',       width: 14 },
            { header: 'Compra s/IVA',      key: 'precioCompraSinIva', width: 14 },
            { header: 'IMEI',              key: 'imei',               width: 20 },
            { header: 'Serial',            key: 'serial',             width: 18 },
            { header: 'Estado',            key: 'estado',             width: 14 },
            { header: 'Vendido',           key: 'vendido',            width: 10 },
            { header: 'Fecha entrada',     key: 'fechaEntrada',       width: 14 },
            { header: 'Fecha venta',       key: 'fechaVenta',         width: 14 },
            { header: 'Observaciones 1',   key: 'observaciones1',     width: 26 },
            { header: 'Observaciones 2',   key: 'observaciones2',     width: 26 },
        ];

        const headerRow = ws.getRow(1);
        headerRow.height = 28;
        headerRow.eachCell(cell => {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1565C0' } };
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 11, name: 'Calibri' };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { bottom: { style: 'medium', color: { argb: 'FF0D47A1' } } };
        });

        ws.views = [{ state: 'frozen', ySplit: 1 }];
        ws.autoFilter = { from: 'A1', to: 'W1' };

        ws.dataValidations.add('B2:B10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Modelo no válido',
            error: 'Selecciona un modelo de la lista',
            formulae: [`Listas!$D$2:$D$${MODELOS.length + 1}`],
        });
        ws.dataValidations.add('C2:C10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Capacidad no válida',
            error: 'Selecciona una capacidad de la lista',
            formulae: [`Listas!$A$2:$A$${CAPACIDADES.length + 1}`],
        });
        ws.dataValidations.add('E2:E10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'RAM no válida',
            error: 'Selecciona una opción de RAM de la lista',
            formulae: [`Listas!$C$2:$C$${RAM_OPTS.length + 1}`],
        });
        ws.dataValidations.add('F2:F10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Color no válido',
            error: 'Selecciona un color de la lista',
            formulae: [`Listas!$B$2:$B$${COLORES.length + 1}`],
        });
        ws.dataValidations.add('G2:G10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Grado no válido',
            error: 'Selecciona: A, B, C o D',
            formulae: ['"A,B,C,D"'],
        });
        ws.dataValidations.add('H2:H10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Condición no válida',
            error: 'Selecciona: Usado o Premium',
            formulae: ['"Usado,Premium"'],
        });
        ws.dataValidations.add('R2:R10000', {
            type: 'list', allowBlank: true, showErrorMessage: true,
            errorStyle: 'warning', errorTitle: 'Estado no válido',
            error: 'Selecciona un estado de la lista',
            formulae: ['"En stock,Reparando,Reservado,Vendido"'],
        });
        ws.dataValidations.add('S2:S10000', {
            type: 'list', allowBlank: true,
            formulae: ['"Sí,No"'],
        });

        const ESTADO_LABELS = { stock: 'En stock', reparacion: 'Reparando', reservado: 'Reservado', vendido: 'Vendido' };
        const toDate        = ts => ts ? new Date(ts).toLocaleDateString('es-ES') : '';
        const moneyFmt = '#,##0.00 €';

        this.props.reacData.forEach((r) => {
            const row = ws.addRow({
                reference:          r.reference || '',
                modelo:             r.modelo || '',
                capacidad:          r.capacidad || '',
                procesador:         r.procesador || '',
                ram:                r.ram || '',
                color:              r.color || '',
                grado:              r.grado || '',
                condicion:          r.condicion === 'premium' ? 'Premium' : (r.condicion ? 'Usado' : ''),
                salud:              r.salud != null ? r.salud : '',
                ciclos:             r.ciclos != null ? r.ciclos : '',
                problemaOriginal:   r.problemaOriginal || '',
                precio:             r.precio != null ? r.precio : '',
                precioSinIva:       r.precioSinIva != null ? r.precioSinIva : '',
                precioCompra:       r.precioCompra != null ? r.precioCompra : '',
                precioCompraSinIva: r.precioCompraSinIva != null ? r.precioCompraSinIva : '',
                imei:               r.imei || '',
                serial:             r.serial || '',
                estado:             ESTADO_LABELS[r.estado] || r.estado || '',
                vendido:            r.vendido ? 'Sí' : 'No',
                fechaEntrada:       toDate(r.fechaEntrada),
                fechaVenta:         toDate(r.fechaVenta),
                observaciones1:     r.observaciones1 || '',
                observaciones2:     r.observaciones2 || '',
            });

            row.height = 20;
            row.eachCell({ includeEmpty: true }, cell => {
                cell.font      = { name: 'Calibri', size: 10 };
                cell.alignment = { vertical: 'middle' };
            });

            const refCell = row.getCell('reference');
            refCell.font   = { bold: true, color: { argb: 'FF1565C0' }, name: 'Calibri', size: 10 };
            refCell.border = { right: { style: 'medium', color: { argb: 'FF1565C0' } } };

            if (r.precio != null) {
                const pc = row.getCell('precio');
                pc.font   = { bold: true, color: { argb: 'FF1B8A1B' }, name: 'Calibri', size: 10 };
                pc.numFmt = moneyFmt;
            }
            ['precioSinIva', 'precioCompra', 'precioCompraSinIva'].forEach(k => {
                if (r[k] != null) row.getCell(k).numFmt = moneyFmt;
            });

            const gc = row.getCell('grado');
            gc.border = {
                top:    { style: 'thin', color: { argb: 'FFBDBDBD' } },
                bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
                left:   { style: 'thin', color: { argb: 'FFBDBDBD' } },
                right:  { style: 'thin', color: { argb: 'FFBDBDBD' } },
            };
            gc.alignment = { horizontal: 'center', vertical: 'middle' };

            const ec = row.getCell('estado');
            ec.border = {
                top:    { style: 'thin', color: { argb: 'FFBDBDBD' } },
                bottom: { style: 'thin', color: { argb: 'FFBDBDBD' } },
                left:   { style: 'thin', color: { argb: 'FFBDBDBD' } },
                right:  { style: 'thin', color: { argb: 'FFBDBDBD' } },
            };
            ec.alignment = { horizontal: 'center', vertical: 'middle' };
        });

        const cfFill = argb => ({ type: 'pattern', pattern: 'solid', bgColor: { argb }, fgColor: { argb } });
        const cfFont = (argb) => ({ bold: true, color: { argb }, name: 'Calibri', size: 10 });

        ws.addConditionalFormatting({
            ref: 'G2:G10000',
            rules: [
                { priority: 1, type: 'expression', formulae: ['$G2="A"'], style: { fill: cfFill('FFC8E6C9'), font: cfFont('FF1B5E20') } },
                { priority: 2, type: 'expression', formulae: ['$G2="B"'], style: { fill: cfFill('FFFFE082'), font: cfFont('FFE65100') } },
                { priority: 3, type: 'expression', formulae: ['$G2="C"'], style: { fill: cfFill('FFEF9A9A'), font: cfFont('FFB71C1C') } },
                { priority: 4, type: 'expression', formulae: ['$G2="D"'], style: { fill: cfFill('FFE0E0E0'), font: cfFont('FF616161') } },
            ],
        });

        ws.addConditionalFormatting({
            ref: 'R2:R10000',
            rules: [
                { priority: 5, type: 'expression', formulae: ['$R2="En stock"'],  style: { fill: cfFill('FFC8E6C9'), font: cfFont('FF1B5E20') } },
                { priority: 6, type: 'expression', formulae: ['$R2="Reparando"'], style: { fill: cfFill('FFFFE082'), font: cfFont('FFE65100') } },
                { priority: 7, type: 'expression', formulae: ['$R2="Reservado"'], style: { fill: cfFill('FF90CAF9'), font: cfFont('FF0D47A1') } },
                { priority: 8, type: 'expression', formulae: ['$R2="Vendido"'],   style: { fill: cfFill('FFE0E0E0'), font: cfFont('FF616161') } },
            ],
        });

        ws.addConditionalFormatting({
            ref: 'A2:W10000',
            rules: [
                { priority: 9,  type: 'expression', formulae: ['$R2="En stock"'],  style: { fill: cfFill('FFE8F5E9') } },
                { priority: 10, type: 'expression', formulae: ['$R2="Reparando"'], style: { fill: cfFill('FFFFF3E0') } },
                { priority: 11, type: 'expression', formulae: ['$R2="Reservado"'], style: { fill: cfFill('FFE3F2FD') } },
                { priority: 12, type: 'expression', formulae: ['$R2="Vendido"'],   style: { fill: cfFill('FFF0F0F0') } },
            ],
        });

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `reacondicionados_${new Date().toISOString().slice(0,10)}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
    };

    handleImport = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.xlsx';
        input.onchange = e => {
            const file = e.target.files[0];
            if (!file) return;
            this.setState({ importProgress: { open: true, current: 0, total: 0 } });
            executeImportExcelReac(
                file,
                result => {
                    this.setState({
                        importProgress: { open: false, current: 0, total: 0 },
                        importDialog:   { open: true, result },
                    });
                },
                (current, total) => {
                    this.setState({ importProgress: { open: true, current, total } });
                },
            );
        };
        input.click();
    };

    handleTest = item => {
        this.setState({ testDialog: { open: true, item } });
    };

    handleCloseTest = () => {
        this.setState({ testDialog: { open: false, item: null } });
    };

    handleCreateTicket = item => {
        const { reacSelected } = this.state;
        const items = reacSelected.length > 0 ? reacSelected : [item];
        this.setState({ confirmDialog: { open: true, type: 'ticket', items } });
    };

    handleCreateInvoice = item => {
        const { reacSelected } = this.state;
        const items = reacSelected.length > 0 ? reacSelected : [item];
        this.setState({ confirmDialog: { open: true, type: 'factura', items } });
    };

    handleCloseConfirmDialog = () => {
        this.setState({ confirmDialog: { open: false, type: null, items: [] } });
    };

    handleConfirmDialog = async () => {
        const { type, items } = this.state.confirmDialog;
        this.handleCloseConfirmDialog();
        try {
            if (type === 'ticket')  await addTicketFromReacUseCase(items);
            if (type === 'factura') await addInvoiceFromReacUseCase(items);
        } catch (err) {
            console.error(`Error al crear ${type}:`, err);
        }
    };

    handleChangeEstado = async (rowData, newEstado) => {
        try {
            const extra = newEstado === 'vendido'
                ? { vendido: true, fechaVenta: rowData.fechaVenta || new Date().getTime() }
                : {};
            await updateReac2({ ...rowData, estado: newEstado, ...extra });
        } catch (err) {
            console.error('Error al cambiar estado:', err);
        }
    };

    handleVender = async item => {
        try {
            await updateReac2({ ...item, estado: 'vendido', fechaVenta: new Date().getTime() });
        } catch (err) {
            console.error('Error al marcar como vendido:', err);
        }
    };

    render() {
        const { reacData, loading } = this.props;
        const { importDialog, importProgress, testDialog, reacSelected, deleteProgress, confirmDialog, orderColumns, searchData } = this.state;

        const columns = this.buildColumns(true, orderColumns);
        const columnsVendidos = this.buildColumns(false, orderColumns);

        const disponibles = filterReacDataByText(reacData.filter(r => r.estado !== 'vendido'), searchData.text);
        const vendidos = filterReacDataByText(reacData.filter(r => r.estado === 'vendido'), searchData.text);

        return (
            <div style={{ padding: 8 }}>
                <SearcherPro
                    textSearch={searchData.text}
                    handleChangeTextSearch={this.handleSearchText}
                />
                {reacSelected.length > 0 && (
                    <div style={{
                        background: '#e3f2fd',
                        border: '1px solid #1565C0',
                        borderRadius: 6,
                        padding: '8px 16px',
                        marginBottom: 8,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 12,
                        fontWeight: 600,
                        color: '#1565C0',
                    }}>
                        {reacSelected.length} artículo{reacSelected.length !== 1 ? 's' : ''} seleccionado{reacSelected.length !== 1 ? 's' : ''}
                        <span
                            onClick={() => this.handleSelectAll(false)}
                            style={{ cursor: 'pointer', fontWeight: 400, fontSize: 13, color: '#1976d2', textDecoration: 'underline' }}
                        >
                            Deseleccionar todos
                        </span>
                    </div>
                )}

                <TableReac
                    tableRef={this.tableRef}
                    data={disponibles}
                    columns={columns}
                    loading={loading}
                    onAdd={this.handleAdd}
                    onUpdate={this.handleUpdate}
                    onDelete={this.handleDelete}
                    onPrintLabel={this.handlePrintLabel}
                    onDuplicate={this.handleDuplicate}
                    onTest={this.handleTest}
                    onCreateTicket={this.handleCreateTicket}
                    onCreateInvoice={this.handleCreateInvoice}
                    onImport={this.handleImport}
                    onDownloadTemplate={this.handleDownloadTemplate}
                    onColumnDrag={this.handleColumnDrag}
                />

                {vendidos.length > 0 && (
                    <div style={{ marginTop: 32 }}>
                        <TableReac
                            tableRef={this.tableRefVendidos}
                            data={vendidos}
                            columns={columnsVendidos}
                            loading={loading}
                            title="Vendidos"
                            onUpdate={this.handleUpdate}
                            onDelete={this.handleDelete}
                            onPrintLabel={this.handlePrintLabel}
                            onDuplicate={this.handleDuplicate}
                            onTest={this.handleTest}
                            onCreateTicket={this.handleCreateTicket}
                            onCreateInvoice={this.handleCreateInvoice}
                        />
                    </div>
                )}

                <ImportProgressDialog
                    open={importProgress.open}
                    current={importProgress.current}
                    total={importProgress.total}
                />

                <DeleteProgressDialog
                    open={deleteProgress.open}
                    current={deleteProgress.current}
                    total={deleteProgress.total}
                />

                <Dialog open={confirmDialog.open} onClose={this.handleCloseConfirmDialog}>
                    <DialogTitle disableTypography style={{ textAlign: 'center' }}>
                        <span style={{ fontSize: 20, fontWeight: 600 }}>
                            {confirmDialog.type === 'ticket' ? 'Crear ticket' : 'Crear factura'}
                        </span>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{ textAlign: 'center' }}>
                            {confirmDialog.items.length > 1
                                ? `¿Seguro que deseas crear ${confirmDialog.type === 'ticket' ? 'un ticket' : 'una factura'} con ${confirmDialog.items.length} artículos seleccionados?`
                                : `¿Seguro que deseas crear ${confirmDialog.type === 'ticket' ? 'un ticket' : 'una factura'} para este artículo?`
                            }
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'center', paddingBottom: 16 }}>
                        <Button onClick={this.handleCloseConfirmDialog}>Cancelar</Button>
                        <Button onClick={this.handleConfirmDialog} color="primary" variant="contained" disableElevation>
                            {confirmDialog.type === 'ticket' ? 'Crear ticket' : 'Crear factura'}
                        </Button>
                    </DialogActions>
                </Dialog>

                <DialogImportReac
                    open={importDialog.open}
                    result={importDialog.result}
                    onClose={() => this.setState({ importDialog: { open: false, result: null } })}
                />

                {testDialog.item && (
                    <TestsDialog
                        open={testDialog.open}
                        onClose={this.handleCloseTest}
                        ticketId={testDialog.item.id}
                        initialResults={testDialog.item.testResults || {}}
                        collection="reacondicionados"
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    reacData: getReacData(state.reacondicionados.data),
    loading: state.reacondicionados.loading,
});

const mapDispatchToProps = {
    addReac,
    getReac,
    updateReac,
    deleteReac,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReacondicionadosContainer);
